module.exports = __webpack_public_path__ + "static/media/share-tw.96fcfb08.svg";